/**
 * @fileoverview gRPC-Web generated client stub for acompanha.transactions.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/transactions/v1/transactions.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.transactions = {};
proto.acompanha.transactions.v1 = require('./transactions_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.transactions.v1.TransactionsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.transactions.v1.TransactionsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.transactions.v1.ListTransactionsRequest,
 *   !proto.acompanha.transactions.v1.ListTransactionsResponse>}
 */
const methodDescriptor_TransactionsService_ListTransactions = new grpc.web.MethodDescriptor(
  '/acompanha.transactions.v1.TransactionsService/ListTransactions',
  grpc.web.MethodType.UNARY,
  proto.acompanha.transactions.v1.ListTransactionsRequest,
  proto.acompanha.transactions.v1.ListTransactionsResponse,
  /**
   * @param {!proto.acompanha.transactions.v1.ListTransactionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.transactions.v1.ListTransactionsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.transactions.v1.ListTransactionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.transactions.v1.ListTransactionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.transactions.v1.ListTransactionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.transactions.v1.TransactionsServiceClient.prototype.listTransactions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.transactions.v1.TransactionsService/ListTransactions',
      request,
      metadata || {},
      methodDescriptor_TransactionsService_ListTransactions,
      callback);
};


/**
 * @param {!proto.acompanha.transactions.v1.ListTransactionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.transactions.v1.ListTransactionsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.transactions.v1.TransactionsServicePromiseClient.prototype.listTransactions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.transactions.v1.TransactionsService/ListTransactions',
      request,
      metadata || {},
      methodDescriptor_TransactionsService_ListTransactions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.transactions.v1.GetTransactionRequest,
 *   !proto.acompanha.transactions.v1.GetTransactionResponse>}
 */
const methodDescriptor_TransactionsService_GetTransaction = new grpc.web.MethodDescriptor(
  '/acompanha.transactions.v1.TransactionsService/GetTransaction',
  grpc.web.MethodType.UNARY,
  proto.acompanha.transactions.v1.GetTransactionRequest,
  proto.acompanha.transactions.v1.GetTransactionResponse,
  /**
   * @param {!proto.acompanha.transactions.v1.GetTransactionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.transactions.v1.GetTransactionResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.transactions.v1.GetTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.transactions.v1.GetTransactionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.transactions.v1.GetTransactionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.transactions.v1.TransactionsServiceClient.prototype.getTransaction =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.transactions.v1.TransactionsService/GetTransaction',
      request,
      metadata || {},
      methodDescriptor_TransactionsService_GetTransaction,
      callback);
};


/**
 * @param {!proto.acompanha.transactions.v1.GetTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.transactions.v1.GetTransactionResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.transactions.v1.TransactionsServicePromiseClient.prototype.getTransaction =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.transactions.v1.TransactionsService/GetTransaction',
      request,
      metadata || {},
      methodDescriptor_TransactionsService_GetTransaction);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.transactions.v1.CreateTransactionRequest,
 *   !proto.acompanha.transactions.v1.CreateTransactionResponse>}
 */
const methodDescriptor_TransactionsService_CreateTransaction = new grpc.web.MethodDescriptor(
  '/acompanha.transactions.v1.TransactionsService/CreateTransaction',
  grpc.web.MethodType.UNARY,
  proto.acompanha.transactions.v1.CreateTransactionRequest,
  proto.acompanha.transactions.v1.CreateTransactionResponse,
  /**
   * @param {!proto.acompanha.transactions.v1.CreateTransactionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.transactions.v1.CreateTransactionResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.transactions.v1.CreateTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.transactions.v1.CreateTransactionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.transactions.v1.CreateTransactionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.transactions.v1.TransactionsServiceClient.prototype.createTransaction =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.transactions.v1.TransactionsService/CreateTransaction',
      request,
      metadata || {},
      methodDescriptor_TransactionsService_CreateTransaction,
      callback);
};


/**
 * @param {!proto.acompanha.transactions.v1.CreateTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.transactions.v1.CreateTransactionResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.transactions.v1.TransactionsServicePromiseClient.prototype.createTransaction =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.transactions.v1.TransactionsService/CreateTransaction',
      request,
      metadata || {},
      methodDescriptor_TransactionsService_CreateTransaction);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.transactions.v1.UpdateTransactionRequest,
 *   !proto.acompanha.transactions.v1.UpdateTransactionResponse>}
 */
const methodDescriptor_TransactionsService_UpdateTransaction = new grpc.web.MethodDescriptor(
  '/acompanha.transactions.v1.TransactionsService/UpdateTransaction',
  grpc.web.MethodType.UNARY,
  proto.acompanha.transactions.v1.UpdateTransactionRequest,
  proto.acompanha.transactions.v1.UpdateTransactionResponse,
  /**
   * @param {!proto.acompanha.transactions.v1.UpdateTransactionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.transactions.v1.UpdateTransactionResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.transactions.v1.UpdateTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.transactions.v1.UpdateTransactionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.transactions.v1.UpdateTransactionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.transactions.v1.TransactionsServiceClient.prototype.updateTransaction =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.transactions.v1.TransactionsService/UpdateTransaction',
      request,
      metadata || {},
      methodDescriptor_TransactionsService_UpdateTransaction,
      callback);
};


/**
 * @param {!proto.acompanha.transactions.v1.UpdateTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.transactions.v1.UpdateTransactionResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.transactions.v1.TransactionsServicePromiseClient.prototype.updateTransaction =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.transactions.v1.TransactionsService/UpdateTransaction',
      request,
      metadata || {},
      methodDescriptor_TransactionsService_UpdateTransaction);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.transactions.v1.DeleteTransactionRequest,
 *   !proto.acompanha.common.v1.SuccessResponse>}
 */
const methodDescriptor_TransactionsService_DeleteTransaction = new grpc.web.MethodDescriptor(
  '/acompanha.transactions.v1.TransactionsService/DeleteTransaction',
  grpc.web.MethodType.UNARY,
  proto.acompanha.transactions.v1.DeleteTransactionRequest,
  acompanha_common_v1_common_pb.SuccessResponse,
  /**
   * @param {!proto.acompanha.transactions.v1.DeleteTransactionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.SuccessResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.transactions.v1.DeleteTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.SuccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.SuccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.transactions.v1.TransactionsServiceClient.prototype.deleteTransaction =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.transactions.v1.TransactionsService/DeleteTransaction',
      request,
      metadata || {},
      methodDescriptor_TransactionsService_DeleteTransaction,
      callback);
};


/**
 * @param {!proto.acompanha.transactions.v1.DeleteTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.SuccessResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.transactions.v1.TransactionsServicePromiseClient.prototype.deleteTransaction =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.transactions.v1.TransactionsService/DeleteTransaction',
      request,
      metadata || {},
      methodDescriptor_TransactionsService_DeleteTransaction);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.transactions.v1.ReconciliationRequest,
 *   !proto.acompanha.transactions.v1.ReconciliationResponse>}
 */
const methodDescriptor_TransactionsService_Reconciliation = new grpc.web.MethodDescriptor(
  '/acompanha.transactions.v1.TransactionsService/Reconciliation',
  grpc.web.MethodType.UNARY,
  proto.acompanha.transactions.v1.ReconciliationRequest,
  proto.acompanha.transactions.v1.ReconciliationResponse,
  /**
   * @param {!proto.acompanha.transactions.v1.ReconciliationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.transactions.v1.ReconciliationResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.transactions.v1.ReconciliationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.transactions.v1.ReconciliationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.transactions.v1.ReconciliationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.transactions.v1.TransactionsServiceClient.prototype.reconciliation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.transactions.v1.TransactionsService/Reconciliation',
      request,
      metadata || {},
      methodDescriptor_TransactionsService_Reconciliation,
      callback);
};


/**
 * @param {!proto.acompanha.transactions.v1.ReconciliationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.transactions.v1.ReconciliationResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.transactions.v1.TransactionsServicePromiseClient.prototype.reconciliation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.transactions.v1.TransactionsService/Reconciliation',
      request,
      metadata || {},
      methodDescriptor_TransactionsService_Reconciliation);
};


module.exports = proto.acompanha.transactions.v1;

